export const getReactEventHandler = ($element, handlerName) => {
  for (const key in $element) {
    if (Object.hasOwn($element, key) && key.startsWith('__reactProps$')) {
      return $element[key][handlerName];
    }
  }
  return null;
};